import React, { memo, useRef } from "react";
import { Dropdown } from "react-bootstrap";
import BsChevronDown from "../../../constants/icons/Bs/BsChevronDown";

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <div
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
  </div>
));

const DashboardDropdown = ({ onItemSelect = () => {} }) => {
  const dropdownRef = useRef(null);

  return (
    <Dropdown ref={dropdownRef}>
      <Dropdown.Toggle
        id="dropdown-basic"
        as={CustomToggle}
        ref={dropdownRef}
        className="transparent-dropdown-toggle"
      >
        <BsChevronDown />
      </Dropdown.Toggle>

      <Dropdown.Menu
        style={{
          padding: "5px",
          borderRadius: "5px",
        }}
      >
        <Dropdown.Item
          onClick={() => {
            onItemSelect("today");
          }}
        >
          Today
        </Dropdown.Item>
        <Dropdown.Item
          onClick={() => {
            onItemSelect("week");
          }}
        >
          This week
        </Dropdown.Item>
        <Dropdown.Item
          onClick={() => {
            onItemSelect("month");
          }}
        >
          This month
        </Dropdown.Item>
        <Dropdown.Item
          onClick={() => {
            onItemSelect("year");
          }}
        >
          This year
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default memo(DashboardDropdown);
